export default {
  common: {
    getDataFailed: 'Gagal mendapatkan data',
    cancel: 'İptal',
    noResult: 'tidak ada hasil',
    prize: 'hadiah',
    totalPrize: 'hadiah total',
    round: 'Jumlah putaran',
    time: 'Waktu',
    address: 'Alamat',
    options: 'Pilihan',
    type: 'Jenis',
    none: 'Tidak ada',
    executedSuccessfully: 'dieksekusi dengan sukses',
  },
  header: {
    referral: 'Direkomendasikan',
    connect: 'Menghubung',
    records: 'Catatan saya',
    register: 'Dibayar/stake',
    disconnect: 'Memutuskan',
    networkHint: 'Harap perhatikan latensi jaringan Anda',
  },
  rules: {
    top: 'Apakah Anda siap untuk tantangan? Kami memiliki 12 pertanyaan dalam satu putaran dan pemenang akan berbagi dalam kumpulan hadiah minimal $10.000.',
    title: 'Aturan',
    section1: 'Batas waktu aplikasi adalah 12:00 GMT, acara dimulai pada 12:05 GMT',
    section2: "Anda perlu mempertaruhkan Lifeform Avatar dan membayar 1 BUSD untuk mendaftar ke acara ini; jika Anda tidak memiliki Lifeform Avatar, Anda harus membayar 20 BUSD untuk pendaftaran tersebut.",
    section3: 'Ada 12 soal. Untuk pertanyaan, Anda memiliki waktu 20 detik untuk memilih jawaban, dan jawaban yang benar akan ditampilkan dalam 5 detik tersisa. Jika Anda menjawab dengan benar, Anda dapat melanjutkan ke pertanyaan berikutnya.',
    section4: 'Saat putaran selesai, Anda dapat membatalkan stake.',
    section5: 'Setelah setiap putaran, hadiah akan dikirimkan ke pemenang melalui udara.',
    section6: 'Kirim link referral ke teman Anda untuk mendapatkan kartu kebangkitan. [Setelah dia menggunakan tautan Anda dan mendaftar untuk acara SuperAvatar, Anda akan mendapatkan kartu kebangkitan]',
    section7: 'Kamu bisa menggunakan kartu revitalisasi untuk melanjutkan permainan. Setiap kartu kebangkitan hanya memberikan satu peluang per giliran.',
    section8: 'Kartu kebangkitan yang tidak digunakan akan secara otomatis kedaluwarsa setelah setiap giliran.',
  },
  home: {
    prizePool: 'Kolam Hadiah',
    totalParticipants: 'Jumlah peserta',
    round: 'Jumlah putaran',
    startIn: 'mulai masuk',
    connect: 'Menghubung',
    register: 'Terdaftar',
    registered: 'Terdaftar',
    enter: 'Memasuki',
    ongoing: 'Sedang berlangsung',
    ended: 'Berakhir',
    cumulativeRanking: 'Peringkat Kumulatif',
  },
  register: {
    registerRecords: 'Catatan Pendaftaran',
    registerForRound: 'Babak pendaftaran',
    youCanChoose: 'Kamu bisa memilih',
    pay: 'Bayar',
    or: 'atau',
    stake: 'stake',
    staked: 'telah distakekan',
    paid: 'dibayar',
    inviteFriends: 'Mengundang teman-teman',
    insufficientFunds: 'Saldo tidak mencukupi',
    registerSuccess: 'Registrasi berhasil',
    registerFail: 'Registrasi gagal',
    onceRegistered: 'Anda akan diberikan medali SuperAvatar untuk babak ini.',
    checkMyMedal: 'Lihat medali saya',
    backToHome: 'Kembali ke halaman rumah',
  },
  records: {
    myTotalPrize: 'Total kemenangan saya',
    myRecordsInSuperAvatar: 'Rekor saya di super avatar',
    round: 'Jumlah putaran',
    totalRegistered: 'Jumlah peserta',
    totalPrize: 'hadiah total',
    winners: 'Pemenang',
    defeat: 'Dikalahkan',
    myPrize: 'Kemenangan saya',
    myRecordsOfPayStake: 'Catatan pembayaran/pertaruhan saya',
  },
  share: {
    share: 'Membagikan',
    referralUrlCopied: 'Undangan yang disalin untuk terhubung',
    showItOff: 'Pamer',
    invitingYouTo: 'mengundang Anda',
    theWinnersTakeAll: 'Pemenang berbagi semua',
    yourReferralUrl: 'Tautan rujukan Anda',
    downloadAndShare: 'Unduh gambar dan bagikan',
    comeToWin: 'Datanglah ke super avatar dan dapatkan bonus!',
    iHaveDefeated: 'Saya telah mengalahkan',
    ofThePlayers1: 'pemain',
    ofThePlayers2: 'dan hampir mendapatkannya',
    isTheWinnerOfThisRound: 'adalah pemenang babak ini',
    hasWon: 'Diperoleh',
    comeToTogether: 'Datang dan menangkan lebih banyak hadiah',
    hereRecordOf: 'Di sini catatan permainan',
    knowMore: 'Pelajari lebih lanjut tentang avatar super',
    iHaveWon: 'Aku telah menang',
    everyDay: 'setiap hari',
    resurrectionCardUsed: 'Kartu kebangkitan digunakan',
    everyDay12GMTAAnswer: 'Setiap hari pada pukul 12 siang (GMT), jawab 12 pertanyaan dengan benar, dan segera bagikan 10.000 BUSD secara merata. Berpartisipasi dalam tautan:',
    totalHighAs: 'hadiah total',
    everyDay12GMT: 'Setiap hari pukul 12PM (GMT)',
    answer12Today1: 'Jawab 12 pertanyaan dengan benar, pemenang akan',
    answer12Today2: 'akan berbagi semua hadiah hari itu secara merata',
    numIHaveDefeated: 'Saya mengalahkan',
    numOfThePlayers1: 'pemain',
    numOfThePlayers2: 'dan hampir mendapatkannya',
    holdDownShare: 'Tahan foto untuk dibagikan',
    win: 'menang',
  },
  stake: {
    registerByStaking: 'Daftar dengan stake',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'Pilih avatar Anda',
    stake: 'stake',
    unstake: 'Batalkan stake',
    unstaked: 'Stake dibatalkan',
    approveToken: 'Harap izinkan kota Anda untuk pendaftaran',
    approveNFT: 'Harap izinkan NFT Anda untuk stake',
  },
  match: {
    watching: 'Menonton',
    sorryYouAreOut: 'Maaf, Anda keluar dari permainan!',
    wishNext: 'Semoga menang di pertandingan berikutnya!',
    totalPrize: 'hadiah total',
    survivedAndTotal: 'Bertahan hidup/Jumlah peserta',
    prizeForEach: 'Bonus per orang',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'Selamat!',
    areWinner: 'Anda adalah pemenang babak ini.',
    almostWinner: 'Anda begitu dekat untuk disebut sebagai pemenang!',
    keepLearning: 'Terus belajar dan menang di babak berikutnya!',
    toGetCard: 'Dapatkan kartu kebangkitan untuk putaran berikutnya',
  },
  referral: {
    currentRound1: 'Ini adalah babak "Sekarang"',
    currentRound2: '',
    inviteYourFriendsTo: 'Undang teman Anda untuk mendapatkan kartu kebangkitan putaran ini!',
    referralRecords: 'Catatan Rujukan',
    round: 'Jumlah putaran',
    resurrectionCard: 'Kartu kebangkitan',
    usedOrNot: 'Digunakan atau tidak',
    invitedUsers: 'Pengguna yang diundang',
    used: 'Digunakan',
    unused: 'Tidak digunakan',
    none: 'Tidak ada',
    viewDetails: 'Melihat rincian',
  },
};